var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.url)?_c('img',{attrs:{"src":_vm.url,"alt":"coin icon","width":"34","height":"34"}}):_c('img',{staticClass:"fallback-logo",attrs:{"src":require("@/assets/logo_group.svg"),"alt":"fallback coin icon","width":"34","height":"34"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4030e7da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/coin/CoinIcon.vue
// module id = null
// module chunks = 